module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "sec-11"
    }
  }, [_c('h1', {
    staticClass: "ct",
    attrs: {
      "id": "pz11-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/contents#toc1",
      "id": "con1"
    }
  }, [_c('i', [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "noind",
    attrs: {
      "id": "pz11-2"
    }
  }, [_c('span', {
    staticClass: "dcap"
  }, [_c('b', [_vm._v("T")])]), _vm._v("o my Proverbs 31 Ministries sisters (and one brother!), especially President Lysa TerKeurst: Serving God with you is my favorite thing to do! I love you all.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz11-4"
    }
  }, [_vm._v("To agent Esther Fedorkevich: Thank you for your encouragement to put together this idea about scattering kindness.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz11-5"
    }
  }, [_vm._v("To my Harper Collins Christian family: Sandy Vander Zicht, Tom Dean, Robin Phillips, John Raymond, TJ Rathbun, and Greg Clouse. Thank you for all you do to get my projects from scribbles on a legal pad to a book and video Bible study in the hands of a woman who needs it. You all are so gifted and gracious.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz11-6"
    }
  }, [_vm._v("To Lori Vandenbosch: Thanks for helping my words to make sense and to make a difference.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz11-7"
    }
  }, [_vm._v("To my prayer wall—four faith-filled friends who daily pound heaven’s doors for my sake: Kim Cordes, Sharon Glasgow, Mary Steinke, and Lindsey Feldpausch. I love you all.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz11-8"
    }
  }, [_vm._v("To my husband, Todd, and kids Kenna, Mitchell, and Spencer: Being a family with you all is a delightful mixture of chaos and love.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz11-9"
    }
  }, [_vm._v("To my Lord and Savior Jesus Christ: For dying on the cross for me, purchasing my way to heaven. Indescribable.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ba7292e4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter03.vue
// module id = 72
// module chunks = 0